module.exports = __webpack_public_path__ + "assets/img/龙志鹏.30a0e60b.jpg";